import Head from 'next/head';
import React from 'react';
import { ArticlesList } from '../components';
import { withLayout } from '../Layout/Layout';

function HotelsLists() {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/hotels`} />
        <meta
          name="description"
          content={
            'Explore a world of luxury hotels and accommodations with First-Class.com. Find reviews, insights, and inspiration for your next stay'
          }
        />
        <title>Hotels: Discover Premium Accommodation Options</title>
      </Head>
      <ArticlesList type="Hotels" heading="Hotels" />
    </>
  );
}

export default withLayout(HotelsLists, true);
